export const siteSettings = {
  name: "Swift Hilton Trade",
  link: "https://swifthilton.net",
  email: "support@swifthilton.net",
  appLink: "https://app.swifthilton.net",
};
